import { createSlice } from "@reduxjs/toolkit";

import {
  EMPTY_PROFILE,
  normalizeStoredUser,
} from "../../../features/profile/consumerMappers";

const initialState = {
  user: null,
  isAuthenticated: false,
  loading: true,
  deviceToken: null,
  pushPermission: "unknown",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.user = action.payload ? normalizeStoredUser(action.payload) : null;
      state.isAuthenticated = true;
      state.loading = false;
    },

    setUser(state, action) {
      state.user = action.payload ? normalizeStoredUser(action.payload) : null;
    },

    setAuthResolved(state, action) {
      state.isAuthenticated = Boolean(action.payload);
      state.loading = false;
    },

    setDeviceToken(state, action) {
      state.deviceToken = action.payload ?? null;
    },

    setPushPermission(state, action) {
      state.pushPermission = action.payload || "unknown";
    },

    logout() {
      return { ...initialState, loading: false };
    },
  },
});

export const selectUserState = (state) => state.user;

export const selectProfile = (state) => state.user.user || EMPTY_PROFILE;

export const selectIsAuthenticated = (state) => state.user.isAuthenticated;

export const selectAuthLoading = (state) => state.user.loading;

export const userSliceActions = userSlice.actions;

export default userSlice.reducer;
